import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

type StylesProps = {
	color: string
	borderColor?: string
	textColor?: string
	buttonBackgroundcolor: string
	buttonHoverBackgroundcolor: string
	isBlank: boolean
}

const useStyles = makeStyles({
	item: (props: StylesProps) => ({
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: 4,
		...ColorUtil.getBackgroundAndContrastColor(props.color),
		border: "1px solid",
		padding: 16,
		borderColor: props.borderColor
	}),
	buttonTexts: (props: StylesProps) => ({
		color: props.textColor
	}),
	button: (props: StylesProps) => ({
		padding: "8px 16px 8px 16px",
		radius: 8,
		height: 48,
		...ColorUtil.getBackgroundAndContrastColor(props.buttonBackgroundcolor),
		fontSize: 14,
		fontWeight: 400,
		lineHeight: 20,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(props.buttonHoverBackgroundcolor),
			cursor: "pointer"
		}
	}),
	text: {
		maxWidth: 370,
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
})

export default useStyles
